export default __webpack_public_path__ + "static/media/cr_node.2dcf298c.jpg";